const EXAM_STATUS_META = {
  'Não realizada': { badgeVariant: 'amber-soft' },
  'Em andamento': { badgeVariant: 'amber-soft' },
  Realizada: { badgeVariant: 'success-soft' }
};

export function getExamStatusMeta(exam) {
  return EXAM_STATUS_META[exam?.status] || { badgeVariant: 'muted' };
}
